import { useStorage } from '@vueuse/core'
import { nextTick, type Ref, unref, watch } from 'vue'
import { type MergeStrategy, PersistenceKeys } from './types'

const PREFIX: string = 'previo_ds-data-table'

export const usePersistenceItem = async <T>(
  namespace: string,
  key: PersistenceKeys,
  value: Ref<T[]>,
  options?: {
    merge?: MergeStrategy<T>
  },
): Promise<void> => {
  const storageKey = `${PREFIX}_${namespace}_${key}`
  const stored = useStorage<T[]>(storageKey, unref(value))

  if (options?.merge) {
    value.value = options.merge(stored.value, unref(value))
  } else {
    value.value = stored.value
  }

  await nextTick()

  watch(
    value,
    (val) => {
      stored.value = val
    },
    { deep: true },
  )
}
